"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSiteSettingApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class WebSiteSettingApi extends runtime.BaseAPI {
    /**
     */
    webSiteSettingDeleteDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['wssWebSiteNo'] != null) {
                queryParameters['wssWebSiteNo'] = requestParameters['wssWebSiteNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteSetting/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    webSiteSettingDeleteDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteSettingDeleteDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    webSiteSettingDeleteImageDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['wssWebSiteNo'] != null) {
                queryParameters['wssWebSiteNo'] = requestParameters['wssWebSiteNo'];
            }
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteSetting/DeleteImage`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    webSiteSettingDeleteImageDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteSettingDeleteImageDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    webSiteSettingGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteSetting/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    webSiteSettingGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.webSiteSettingGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站設定-編輯頁查詢
     */
    webSiteSettingGetByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['No'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteSetting/GetById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站設定-編輯頁查詢
     */
    webSiteSettingGetByIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteSettingGetByIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    webSiteSettingGetFooterGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['webSiteNo'] != null) {
                queryParameters['WebSiteNo'] = requestParameters['webSiteNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteSetting/GetFooter`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    webSiteSettingGetFooterGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteSettingGetFooterGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站設定-分頁查詢
     */
    webSiteSettingGetPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteSetting/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WebSiteSettingSearchModelToJSON)(requestParameters['webSiteSettingSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站設定-分頁查詢
     */
    webSiteSettingGetPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteSettingGetPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站設定-Css下拉選單
     */
    webSiteSettingGetWebSiteListGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteSetting/GetWebSiteList`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站設定-Css下拉選單
     */
    webSiteSettingGetWebSiteListGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.webSiteSettingGetWebSiteListGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站設定-編輯
     */
    webSiteSettingPatchPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['wssWebSiteNo'] != null) {
                formParams.append('WssWebSiteNo', requestParameters['wssWebSiteNo']);
            }
            if (requestParameters['wssOrgId'] != null) {
                formParams.append('WssOrgId', requestParameters['wssOrgId']);
            }
            if (requestParameters['wssWebSiteName'] != null) {
                formParams.append('WssWebSiteName', requestParameters['wssWebSiteName']);
            }
            if (requestParameters['wssWebSiteUrl'] != null) {
                formParams.append('WssWebSiteUrl', requestParameters['wssWebSiteUrl']);
            }
            if (requestParameters['wssLineActive'] != null) {
                formParams.append('WssLineActive', requestParameters['wssLineActive']);
            }
            if (requestParameters['wssLineUrl'] != null) {
                formParams.append('WssLineUrl', requestParameters['wssLineUrl']);
            }
            if (requestParameters['wssMessengerActive'] != null) {
                formParams.append('WssMessengerActive', requestParameters['wssMessengerActive']);
            }
            if (requestParameters['wssMessengerUrl'] != null) {
                formParams.append('WssMessengerUrl', requestParameters['wssMessengerUrl']);
            }
            if (requestParameters['wssWebPageLogo'] != null) {
                formParams.append('WssWebPageLogo', requestParameters['wssWebPageLogo']);
            }
            if (requestParameters['pageLogoSource'] != null) {
                formParams.append('PageLogoSource', requestParameters['pageLogoSource']);
            }
            if (requestParameters['wssWebSiteLogo'] != null) {
                formParams.append('WssWebSiteLogo', requestParameters['wssWebSiteLogo']);
            }
            if (requestParameters['siteLogoSource'] != null) {
                formParams.append('SiteLogoSource', requestParameters['siteLogoSource']);
            }
            if (requestParameters['wssWebSiteCss'] != null) {
                formParams.append('WssWebSiteCss', requestParameters['wssWebSiteCss']);
            }
            if (requestParameters['wssMenuFontSize'] != null) {
                formParams.append('WssMenuFontSize', requestParameters['wssMenuFontSize']);
            }
            if (requestParameters['wssBackgroundColor'] != null) {
                formParams.append('WssBackgroundColor', requestParameters['wssBackgroundColor']);
            }
            if (requestParameters['wssActiveFlag'] != null) {
                formParams.append('WssActiveFlag', requestParameters['wssActiveFlag']);
            }
            if (requestParameters['webPageLogoFile'] != null) {
                formParams.append('WebPageLogoFile', requestParameters['webPageLogoFile']);
            }
            if (requestParameters['webSiteLogoFile'] != null) {
                formParams.append('WebSiteLogoFile', requestParameters['webSiteLogoFile']);
            }
            if (requestParameters['wssFooterMenuNo'] != null) {
                formParams.append('WssFooterMenuNo', requestParameters['wssFooterMenuNo']);
            }
            if (requestParameters['wssShoppingCar'] != null) {
                formParams.append('WssShoppingCar', requestParameters['wssShoppingCar']);
            }
            if (requestParameters['wssMenuFontColor'] != null) {
                formParams.append('WssMenuFontColor', requestParameters['wssMenuFontColor']);
            }
            if (requestParameters['wssLogoposition'] != null) {
                formParams.append('WssLogoposition', requestParameters['wssLogoposition']);
            }
            if (requestParameters['wssStyleWidth'] != null) {
                formParams.append('WssStyleWidth', requestParameters['wssStyleWidth']);
            }
            if (requestParameters['wssProductSearchFlag'] != null) {
                formParams.append('WssProductSearchFlag', requestParameters['wssProductSearchFlag']);
            }
            if (requestParameters['wssMemberFlag'] != null) {
                formParams.append('WssMemberFlag', requestParameters['wssMemberFlag']);
            }
            if (requestParameters['wssShoppingCartFlag'] != null) {
                formParams.append('WssShoppingCartFlag', requestParameters['wssShoppingCartFlag']);
            }
            if (requestParameters['wssMenuBgColor'] != null) {
                formParams.append('WssMenuBgColor', requestParameters['wssMenuBgColor']);
            }
            if (requestParameters['wssMenuIconColor'] != null) {
                formParams.append('WssMenuIconColor', requestParameters['wssMenuIconColor']);
            }
            if (requestParameters['wssMenuIconPosition'] != null) {
                formParams.append('WssMenuIconPosition', requestParameters['wssMenuIconPosition']);
            }
            if (requestParameters['wssOrderTransfer'] != null) {
                formParams.append('WssOrderTransfer', requestParameters['wssOrderTransfer']);
            }
            if (requestParameters['wssOrderText'] != null) {
                formParams.append('WssOrderText', requestParameters['wssOrderText']);
            }
            if (requestParameters['wssPackingWay'] != null) {
                formParams.append('WssPackingWay', requestParameters['wssPackingWay']);
            }
            if (requestParameters['wssPickupMethod'] != null) {
                formParams.append('WssPickupMethod', requestParameters['wssPickupMethod']);
            }
            if (requestParameters['wssTitle'] != null) {
                formParams.append('WssTitle', requestParameters['wssTitle']);
            }
            if (requestParameters['wssDescription'] != null) {
                formParams.append('WssDescription', requestParameters['wssDescription']);
            }
            if (requestParameters['wssKeywords'] != null) {
                formParams.append('WssKeywords', requestParameters['wssKeywords']);
            }
            if (requestParameters['wssEnableLineLiff'] != null) {
                formParams.append('WssEnableLineLiff', requestParameters['wssEnableLineLiff']);
            }
            if (requestParameters['wssLiffUrl'] != null) {
                formParams.append('WssLiffUrl', requestParameters['wssLiffUrl']);
            }
            if (requestParameters['wssOrderExpireHours'] != null) {
                formParams.append('WssOrderExpireHours', requestParameters['wssOrderExpireHours']);
            }
            if (requestParameters['wssCancelOrderHours'] != null) {
                formParams.append('WssCancelOrderHours', requestParameters['wssCancelOrderHours']);
            }
            if (requestParameters['wssRefundNoticeContent'] != null) {
                formParams.append('WssRefundNoticeContent', requestParameters['wssRefundNoticeContent']);
            }
            const response = yield this.request({
                path: `/WebSiteSetting/Patch`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站設定-編輯
     */
    webSiteSettingPatchPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteSettingPatchPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站設定-新增
     */
    webSiteSettingPostPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['wssWebSiteNo'] != null) {
                formParams.append('WssWebSiteNo', requestParameters['wssWebSiteNo']);
            }
            if (requestParameters['wssOrgId'] != null) {
                formParams.append('WssOrgId', requestParameters['wssOrgId']);
            }
            if (requestParameters['wssWebSiteName'] != null) {
                formParams.append('WssWebSiteName', requestParameters['wssWebSiteName']);
            }
            if (requestParameters['wssWebSiteUrl'] != null) {
                formParams.append('WssWebSiteUrl', requestParameters['wssWebSiteUrl']);
            }
            if (requestParameters['wssLineActive'] != null) {
                formParams.append('WssLineActive', requestParameters['wssLineActive']);
            }
            if (requestParameters['wssLineUrl'] != null) {
                formParams.append('WssLineUrl', requestParameters['wssLineUrl']);
            }
            if (requestParameters['wssMessengerActive'] != null) {
                formParams.append('WssMessengerActive', requestParameters['wssMessengerActive']);
            }
            if (requestParameters['wssMessengerUrl'] != null) {
                formParams.append('WssMessengerUrl', requestParameters['wssMessengerUrl']);
            }
            if (requestParameters['wssWebPageLogo'] != null) {
                formParams.append('WssWebPageLogo', requestParameters['wssWebPageLogo']);
            }
            if (requestParameters['pageLogoSource'] != null) {
                formParams.append('PageLogoSource', requestParameters['pageLogoSource']);
            }
            if (requestParameters['wssWebSiteLogo'] != null) {
                formParams.append('WssWebSiteLogo', requestParameters['wssWebSiteLogo']);
            }
            if (requestParameters['siteLogoSource'] != null) {
                formParams.append('SiteLogoSource', requestParameters['siteLogoSource']);
            }
            if (requestParameters['wssWebSiteCss'] != null) {
                formParams.append('WssWebSiteCss', requestParameters['wssWebSiteCss']);
            }
            if (requestParameters['wssMenuFontSize'] != null) {
                formParams.append('WssMenuFontSize', requestParameters['wssMenuFontSize']);
            }
            if (requestParameters['wssBackgroundColor'] != null) {
                formParams.append('WssBackgroundColor', requestParameters['wssBackgroundColor']);
            }
            if (requestParameters['wssActiveFlag'] != null) {
                formParams.append('WssActiveFlag', requestParameters['wssActiveFlag']);
            }
            if (requestParameters['webPageLogoFile'] != null) {
                formParams.append('WebPageLogoFile', requestParameters['webPageLogoFile']);
            }
            if (requestParameters['webSiteLogoFile'] != null) {
                formParams.append('WebSiteLogoFile', requestParameters['webSiteLogoFile']);
            }
            if (requestParameters['wssFooterMenuNo'] != null) {
                formParams.append('WssFooterMenuNo', requestParameters['wssFooterMenuNo']);
            }
            if (requestParameters['wssShoppingCar'] != null) {
                formParams.append('WssShoppingCar', requestParameters['wssShoppingCar']);
            }
            if (requestParameters['wssMenuFontColor'] != null) {
                formParams.append('WssMenuFontColor', requestParameters['wssMenuFontColor']);
            }
            if (requestParameters['wssLogoposition'] != null) {
                formParams.append('WssLogoposition', requestParameters['wssLogoposition']);
            }
            if (requestParameters['wssStyleWidth'] != null) {
                formParams.append('WssStyleWidth', requestParameters['wssStyleWidth']);
            }
            if (requestParameters['wssProductSearchFlag'] != null) {
                formParams.append('WssProductSearchFlag', requestParameters['wssProductSearchFlag']);
            }
            if (requestParameters['wssMemberFlag'] != null) {
                formParams.append('WssMemberFlag', requestParameters['wssMemberFlag']);
            }
            if (requestParameters['wssShoppingCartFlag'] != null) {
                formParams.append('WssShoppingCartFlag', requestParameters['wssShoppingCartFlag']);
            }
            if (requestParameters['wssMenuBgColor'] != null) {
                formParams.append('WssMenuBgColor', requestParameters['wssMenuBgColor']);
            }
            if (requestParameters['wssMenuIconColor'] != null) {
                formParams.append('WssMenuIconColor', requestParameters['wssMenuIconColor']);
            }
            if (requestParameters['wssMenuIconPosition'] != null) {
                formParams.append('WssMenuIconPosition', requestParameters['wssMenuIconPosition']);
            }
            if (requestParameters['wssOrderTransfer'] != null) {
                formParams.append('WssOrderTransfer', requestParameters['wssOrderTransfer']);
            }
            if (requestParameters['wssOrderText'] != null) {
                formParams.append('WssOrderText', requestParameters['wssOrderText']);
            }
            if (requestParameters['wssPackingWay'] != null) {
                formParams.append('WssPackingWay', requestParameters['wssPackingWay']);
            }
            if (requestParameters['wssPickupMethod'] != null) {
                formParams.append('WssPickupMethod', requestParameters['wssPickupMethod']);
            }
            if (requestParameters['wssTitle'] != null) {
                formParams.append('WssTitle', requestParameters['wssTitle']);
            }
            if (requestParameters['wssDescription'] != null) {
                formParams.append('WssDescription', requestParameters['wssDescription']);
            }
            if (requestParameters['wssKeywords'] != null) {
                formParams.append('WssKeywords', requestParameters['wssKeywords']);
            }
            if (requestParameters['wssEnableLineLiff'] != null) {
                formParams.append('WssEnableLineLiff', requestParameters['wssEnableLineLiff']);
            }
            if (requestParameters['wssLiffUrl'] != null) {
                formParams.append('WssLiffUrl', requestParameters['wssLiffUrl']);
            }
            if (requestParameters['wssOrderExpireHours'] != null) {
                formParams.append('WssOrderExpireHours', requestParameters['wssOrderExpireHours']);
            }
            if (requestParameters['wssCancelOrderHours'] != null) {
                formParams.append('WssCancelOrderHours', requestParameters['wssCancelOrderHours']);
            }
            if (requestParameters['wssRefundNoticeContent'] != null) {
                formParams.append('WssRefundNoticeContent', requestParameters['wssRefundNoticeContent']);
            }
            const response = yield this.request({
                path: `/WebSiteSetting/Post`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站設定-新增
     */
    webSiteSettingPostPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteSettingPostPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.WebSiteSettingApi = WebSiteSettingApi;
